import { render } from "./Searching.vue?vue&type=template&id=67f69bc2"
import script from "./Searching.vue?vue&type=script&lang=js"
export * from "./Searching.vue?vue&type=script&lang=js"

import exportComponent from "/codebuild/output/src886087124/src/dt-dashboard-client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__